import { render, staticRenderFns } from "./profession.vue?vue&type=template&id=4236a50a&scoped=true"
import script from "./profession.vue?vue&type=script&lang=js"
export * from "./profession.vue?vue&type=script&lang=js"
import style0 from "./profession.vue?vue&type=style&index=0&id=4236a50a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4236a50a",
  null
  
)

export default component.exports